const NetInfo = null

export default NetInfo
